import React from 'react'
import { useRouter } from 'next/navigation'

import { useIsDesktop } from '@rewardops/ui'

import { useFilterBySegmentationTags } from '../hooks/use-filter-by-segmentation-tags'
import MapleButton from '../maple/components/button'

type Link = {
  id: string
  isRelativeUrl: boolean
  name: string
  to: string
}

type PageBannerProps = {
  content: {
    id: string
    title?: string
    subtitle?: string
    image: {
      title: string
      file: {
        url: string
      }
    }
    imageMobile?: {
      title: string
      file: {
        url: string
      }
    }
    links: Link[]
    fontColor?: string
    _type: string
  }
  segmentationTags?: string
}

const PageBanner: React.FC<PageBannerProps> = ({
  content,
}: PageBannerProps) => {
  const { push } = useRouter()

  const isDesktop = useIsDesktop()

  const isBannerSupportedForSegment = useFilterBySegmentationTags({
    bannerContent: content as any,
  })

  const bannerSrc = isDesktop
    ? content?.image?.file?.url
    : content?.imageMobile
    ? content?.imageMobile?.file?.url
    : content?.image?.file?.url

  const handleClick = (link: Link) => {
    if (link?.isRelativeUrl == false) {
      window?.open(link?.to, '_blank')
      return
    }

    push(link?.to)
  }

  if (!Boolean(isBannerSupportedForSegment)) {
    return null
  }

  return (
    <div className="col-span-2 h-[350px] py-6">
      <div className="relative h-full">
        <img
          className="h-full w-full object-cover lg:rounded-lg"
          alt={content?.image?.title}
          src={bannerSrc}
        />
        {Boolean(content?.title) || Boolean(content?.subtitle) ? (
          <div
            className="absolute top-1/3 w-full text-center"
            style={{ color: content?.fontColor ?? '#000000' }}
          >
            <div className="flex flex-col items-center gap-6">
              {content?.title ? (
                <div className="text-4xl font-semibold">{content?.title}</div>
              ) : null}

              {content?.subtitle ? (
                <div className="text-base font-medium">{content?.subtitle}</div>
              ) : null}

              {content?.links?.length ? (
                <div className="flex gap-8">
                  {content?.links?.map((link) => (
                    <MapleButton
                      key={link?.id}
                      id={link?.id}
                      onClick={() => handleClick(link)}
                    >
                      {link?.name}
                    </MapleButton>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export { PageBanner }
